module.exports = __webpack_public_path__ + "img/icon-arrow-right-active.6a6cf09f.svg";